// By default, Klaro will load the config from  a global "klaroConfig" variable.
// You can change this by specifying the "data-config" attribute on your
// script take, e.g. like this:
// <script src="klaro.js" data-config="myConfigVariableName" />
// You can also disable auto-loading of the consent notice by adding
// data-no-auto-load=true to the script tag.
export const klaroConfig = {
    // You can customize the ID of the DIV element that Klaro will create
    // when starting up. If undefined, Klaro will use 'klaro'.
    elementID: 'klaro',

    // You can override CSS style variables here. For IE11, Klaro will
    // dynamically inject the variables into the CSS. If you still consider
    // supporting IE9-10 (which you probably shouldn't) you need to use Klaro
    // with an external stylesheet as the dynamic replacement won't work there.
    styling: {
        theme: ['light', 'top', 'wide'],
    },

    // You can show a description in contextual consent overlays for store
    // being empty. In that case the accept always button is omitted.
    // The description contains a link for opening the consent manager.
    showDescriptionEmptyStore: true,

    // Setting this to true will keep Klaro from automatically loading itself
    // when the page is being loaded.
    noAutoLoad: false,

    // Setting this to true will render the descriptions of the consent
    // modal and consent notice are HTML. Use with care.
    htmlTexts: true,

    // Setting 'embedded' to true will render the Klaro modal and notice without
    // the modal background, allowing you to e.g. embed them into a specific element
    // of your website, such as your privacy notice.
    embedded: false,

    // You can group services by their purpose in the modal. This is advisable
    // if you have a large number of services. Users can then enable or disable
    // entire groups of services instead of having to enable or disable every service.
    groupByPurpose: false,

    // You can make the consent notice autofocused by enabling the following option
    autoFocus: false,

    // You can show a title in the consent notice by enabling the following option
    showNoticeTitle: false,

    // How Klaro should store the user's preferences. It can be either 'cookie'
    // (the default) or 'localStorage'.
    storageMethod: 'cookie',

    // You can customize the name of the cookie that Klaro uses for storing
    // user consent decisions. If undefined, Klaro will use 'klaro'.
    cookieName: 'klaro',

    // You can also set a custom expiration time for the Klaro cookie.
    // By default, it will expire after 120 days.
    cookieExpiresAfterDays: 30,

    // You can change to cookie domain for the consent manager itself.
    // Use this if you want to get consent once for multiple matching domains.
    // If undefined, Klaro will use the current domain.
    //cookieDomain: '.github.com',

    // You can change to cookie path for the consent manager itself.
    // Use this to restrict the cookie visibility to a specific path.
    // If undefined, Klaro will use '/' as cookie path.
    //cookiePath: '/',

    // Defines the default state for services (true=enabled by default).
    default: false,

    // If "mustConsent" is set to true, Klaro will directly display the consent
    // manager modal and not allow the user to close it before having actively
    // consented or declines the use of third-party services.
    mustConsent: false,

    // Show "accept all" to accept all services instead of "ok" that only accepts
    // required and "default: true" services
    acceptAll: true,

    // replace "decline" with cookie manager modal
    hideDeclineAll: true,

    // hide "learnMore" link
    hideLearnMore: false,

    // show cookie notice as modal
    noticeAsModal: true,

    // You can also remove the 'Realized with Klaro!' text in the consent modal.
    // Please don't do this! We provide Klaro as a free open source tool.
    // Placing a link to our website helps us spread the word about it,
    // which ultimately enables us to make Klaro! better for everyone.
    // So please be fair and keep the link enabled. Thanks :)
    disablePoweredBy: true,

    // you can specify an additional class (or classes) that will be added to the Klaro `div`
    //additionalClass: 'my-klaro',

    // You can define the UI language directly here. If undefined, Klaro will
    // use the value given in the global "lang" variable. If that does
    // not exist, it will use the value given in the "lang" attribute of your
    // HTML tag. If that also doesn't exist, it will use 'en'.
    //lang: 'en',

    // You can overwrite existing translations and add translations for your
    // service descriptions and purposes. See `src/translations/` for a full
    // list of translations that can be overwritten:
    // https://github.com/KIProtect/klaro/tree/master/src/translations

    translations: {
        // If you erase the "consentModal" translations, Klaro will use the
        // bundled translations.
        de: {
            acceptSelected: 'Auswahl speichern',
            ok: 'Akzeptieren',
            consentNotice: {
                description: '<p class="h4">Nur kurz die Cookies</p> Wir nutzen externe Dienste, die Cookies und Nutzungsdaten speichern. dazu gehören folgende Integrationen: {purposes}. Um mit uns in Kontakt zu treten und alle Inhalte sehen zu können, akzeptieren Sie bitte die Cookies. Sie können Ihre Zustimmung später jederzeit ändern oder zurückziehen.',
                learnMore: 'Details anzeigen',
            },
            consentModal: {
                title: '<p class="h4">Details zu unseren externen Diensten</p> ',
                description:
                    'Wir vewenden die folgenden Dienste und informieren Sie darüber, welche Cookies wir dafür benötigen.',
            },
            googleAnalytics: {
                description: 'Wir erfassen anonymisierte Daten für Statistiken und Analysen. Mit diesen Daten können wir zum Beispiel die Besucherzahlen messen, feststellen wie gut der Nutzer mit der Seite zurecht kommt und diese dementsprechend optimieren.',
            },
            purposes: {
                analytics: 'Besucher-Statistiken',
                styling: 'Anzeige von Videos',
            }
        },
        en: {
            acceptSelected: 'Accept selected',
            ok: 'Accept',
            consentNotice: {
                description: '<p class="h4">Just a quick word about cookies</p> We use external services that store cookies and usage data. These include the following integrations: {purposes}. To contact us and view all content, please accept cookies. You can change or withdraw your consent at any time.',
                learnMore: 'Show details',
            },
            consentModal: {
                description:
                    'Here you can see and customize the information that we collect about you.',
            },
            googleAnalytics: {
                description: 'We collect anonymous data for statistics and analytics. With this data we can count the number of visitors, see how good the user can interact with the page and optimize it this way.',
            },
            purposes: {
                analytics: 'Analytics',
                styling: 'Show Proven expert images, Videos or the live chat'
            }
        }
    },

    // This is a list of third-party apps that Klaro will manage for you.
    services: [
        // The apps will appear in the modal in the same order as defined here.
        {
            name: 'googleAnalytics',
            title: 'Google Analytics',
            purposes: ['analytics'],
            cookies: ['tracking'],
        },
        {
            name: 'youtube',
            title: 'Youtube-Videos',
            purposes: ['styling'],
            cookies: ['tracking'],
        }/*,
        {
            name: 'partnerIntergration',
            title: 'Proven Expert, BaufiLead, eTermin, FG Video-Service, Tawk Live-Chat',
            purposes: ['communication'],
            cookies: ['tracking'],
            default: true,
        }*/
    ]
};

export default klaroConfig;
